// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3x7E9","boxTitle":"Qualiphy_boxTitle__2_UVV","box":"Qualiphy_box__1ZVb1","toggleWrap":"Qualiphy_toggleWrap__uMyFV"};